var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPhone = function SvgIcPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.831 14.433v2.5a1.666 1.666 0 0 1-1.816 1.667 16.49 16.49 0 0 1-7.192-2.559 16.25 16.25 0 0 1-5-5 16.492 16.492 0 0 1-2.558-7.225A1.667 1.667 0 0 1 3.923 2h2.5A1.667 1.667 0 0 1 8.09 3.433c.105.8.3 1.586.583 2.342a1.667 1.667 0 0 1-.375 1.758L7.24 8.591a13.333 13.333 0 0 0 5 5l1.058-1.058a1.667 1.667 0 0 1 1.758-.375c.756.282 1.542.478 2.342.584a1.667 1.667 0 0 1 1.433 1.691Z"
  })));
};
export default SvgIcPhone;